// Offline fallback for the service-type picker if the GET /api/v1/service-types
// catalog fetch fails (offline, gateway down). Mirrors mobile's
// FALLBACK_SERVICE_TYPES in CreateServiceRequestScreen/InviteSomeoneScreen — the
// runtime fetch (CreateServiceRequestPage.js / InviteSomeonePage.js) is
// authoritative and overwrites this the moment the response lands.
export const SERVICE_TYPE_OPTIONS = [
  { id: 'mortgage_broker',         name: 'Mortgage Broker' },
  { id: 'home_inspection',         name: 'Home Inspection' },
  { id: 'termite_pest_inspection', name: 'Termite / Pest Inspection' },
  { id: 'appraisal',               name: 'Appraisal' },
  { id: 'photography',             name: 'Photography' },
  { id: 'videography',             name: 'Videography' },
  { id: 'contractor_repairs',      name: 'Contractor / Repairs' },
  { id: 'cleaning',                name: 'Cleaning (optional)' },
  { id: 'roof_inspection',         name: 'Roof Inspection' },
  { id: 'sewer_septic_inspection', name: 'Sewer / Septic Inspection' },
  { id: 'pool_inspection',         name: 'Pool Inspection' },
  { id: 'other',                   name: 'Other' },
];
